import { Button, Popover } from "@mui/material"
import { useState } from "react"
import { useMacros } from "authoring/routes/macro/hooks/use-macros"
import Iconify from "minimals-template/components/Iconify"

export function useChipExpander({ macroMap: macroMapOverride } = {}) {
    const { macroMap: fallbackMacroMap } = useMacros()
    const [chipPopover, setChipPopover] = useState(null)

    const popover = (
        <Popover
            open={!!chipPopover}
            anchorEl={chipPopover?.anchorEl}
            onClose={closePopover}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            slotProps={{ paper: { sx: { p: 0.5, mt: 0.5 } } }}
        >
            <Button
                size="small"
                startIcon={<Iconify icon="mdi:text-box-outline" width={16} />}
                onClick={expandChip}
                sx={{ textTransform: "none", fontSize: "0.8rem" }}
                data-cy="expand-macro-button"
            >
                Expand to editable text
            </Button>
        </Popover>
    )

    return { handleChipClick: handleChipClickImpl, chipExpanderPopover: popover }

    function handleChipClickImpl(event) {
        const chip = event.target.classList?.contains("macro-chip")
            ? event.target
            : event.target.closest?.(".macro-chip")
        if (!chip) return
        const tokenId = chip.getAttribute("data-macro-token")
        if (!tokenId) return
        event.preventDefault()
        event.stopPropagation()
        setChipPopover({ anchorEl: chip, tokenId, chip })
    }

    function closePopover() {
        setChipPopover(null)
    }

    function expandChip() {
        if (!chipPopover) return
        const { tokenId, chip } = chipPopover
        const expandedContent = resolveExpandedChipContent({
            tokenId,
            macroMap: macroMapOverride,
            fallbackMacroMap,
        })
        if (!expandedContent || !chip) {
            closePopover()
            return
        }
        const editable = chip.closest("[contenteditable='true']")
        if (!editable) {
            closePopover()
            return
        }
        chip.replaceWith(document.createRange().createContextualFragment(expandedContent))
        editable.dispatchEvent(new Event("input", { bubbles: true }))
        closePopover()
    }
}

export function resolveExpandedChipContent({ tokenId, macroMap, fallbackMacroMap }) {
    const macro = macroMap?.[tokenId] ?? fallbackMacroMap?.[tokenId]
    return macro?.content ?? macro?.contentHtml ?? null
}
